import { createApp } from 'vue'
import App from './App.vue'
import { createMetaManager } from 'vue-meta'
import { createI18n } from 'vue-i18n'
import router from "./router/router"

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faLocationDot,faPhoneFlip } from '@fortawesome/free-solid-svg-icons'

// Import your language detection logic from a separate file
// import { getCurrentLanguage } from './language';

/* add icons to the library */
library.add(faLocationDot,faPhoneFlip)

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';

// Create the Vue app
const app = createApp(App)

app.mixin({
  beforeCreate() {
    // Fetch the current locale from WordPress
    const locale = window.__LANGUAGE__;
    // Set the locale in the Vue app
    this.$locale = locale;
    // console.log('this.$locale',this.$locale)
  },
});

// const language = getCurrentLanguage(); // Call the language detection function
// console.log('this.$language',language)

// Use the detected language as necessary in your Vue app
// app.prototype.$language = language;

// const i18n = createI18n({
//   locale: 'en', // Default locale
//   messages: {
//     en: {
//       // English translations
//     },
//     he: {
//       // Hebrew translations
//     },
//     // Add more locales and translations as needed
//   },
// })


// console.log('app.config.globalProperties',app.config.globalProperties)
// app.config.globalProperties.$publicPath = window.vueAppData.currentLanguage + '/cs-restaurants/';
// console.log('app.config.globalProperties.$publicPath',app.config.globalProperties.$publicPath)
// console.log('window.vueAppData.currentLanguage',window.vueAppData.currentLanguage)

// const currentLanguage = ( window.vueAppData.currentLanguage === 'en_US' )? 'en': 'he';
// // Set the process.env variables
// process.env.VUE_APP_CURRENT_LANGUAGE = currentLanguage;

const metaManager = createMetaManager()
app.use(metaManager)

app.config.productionTip = false

// Enable debug mode
// app.config.devtools = true;

// Use the router plugin
app.use(router)

app.component('font-awesome-icon', FontAwesomeIcon)

// app.use(i18n)

// Mount the app
app.mount('#app')

//refresh on back and forward button
window.onpopstate = function () {
    location.reload()
};
